interface LoadingScreenProps {
  message?: string;
}

export function LoadingScreen({ message = 'Loading...' }: LoadingScreenProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-12 h-12 mb-4">
          <div className="w-8 h-8 border-3 border-tailorcast-primary border-t-transparent rounded-full animate-spin" />
        </div>
        <p className="text-gray-600">{message}</p>
      </div>
    </div>
  );
}
